import React from 'react';

const Sidebar = ({ activeTab, setActiveTab, audioState, playTrack, setShowShop, signOut, player }) => {
  const initial = player?.name ? player.name.charAt(0).toUpperCase() : 'M';

  const getNavBtnStyle = (isActive) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 15px',
    width: '100%',
    border: 'none',
    backgroundColor: isActive ? 'rgba(255, 255, 255, 0.05)' : 'transparent',
    borderLeft: isActive ? '4px solid var(--accent-red)' : '4px solid transparent',
    color: isActive ? '#ffffff' : 'rgba(238, 221, 195, 0.8)',
    fontFamily: 'Cinzel, serif',
    fontSize: '1.05rem',
    letterSpacing: '1px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    outline: 'none',
    fontWeight: isActive ? 'bold' : 'normal',
    transform: isActive ? 'translateX(4px)' : 'none',
    borderRadius: '6px',
  });

  const handleMouseOver = (e, isActive) => {
    if (!isActive) {
      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
      e.currentTarget.style.color = '#ffffff';
      e.currentTarget.style.borderLeft = '4px solid var(--accent-red)';
      e.currentTarget.style.transform = 'translateX(4px)';
    }
  };

  const handleMouseOut = (e, isActive) => {
    if (!isActive) {
      e.currentTarget.style.backgroundColor = 'transparent';
      e.currentTarget.style.color = 'rgba(238, 221, 195, 0.8)';
      e.currentTarget.style.borderLeft = '4px solid transparent';
      e.currentTarget.style.transform = 'none';
    }
  };

  return (
    <aside className="sidebar" style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      padding: '40px 0 20px 0',
      width: '260px',
      background: 'var(--sidebar-bg)',
      boxShadow: '10px 0 20px rgba(0,0,0,0.5)', 
      borderRight: '4px solid var(--muted-gold)', 
      zIndex: 100,
      overflowY: 'auto'
    }}>
      
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '40px', width: '100%' }}>
        <div style={{
          width: '110px', height: '110px', borderRadius: '50%', 
          backgroundColor: '#1a0f0a', border: '2px solid var(--muted-gold)', 
          boxShadow: '0 4px 10px rgba(0,0,0,0.5)',
          display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden',
          position: 'relative', flexShrink: 0
        }}>
          {player?.avatarUrl ? (
            <img src={player.avatarUrl} alt="Avatar" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
          ) : (
            <span style={{fontFamily: 'Cinzel, serif', fontSize: '3.5rem', color: 'var(--muted-gold)'}}>{initial}</span>
          )}
        </div>
      </div>

      <nav className="nav-menu" style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '0 10px' }}>
        <button 
          style={getNavBtnStyle(activeTab === 'dashboard')} 
          onClick={() => setActiveTab('dashboard')}
          onMouseOver={(e) => handleMouseOver(e, activeTab === 'dashboard')}
          onMouseOut={(e) => handleMouseOut(e, activeTab === 'dashboard')}
        >
          <span style={{ fontSize: '1.2rem' }}>🏛️</span> Dashboard
        </button>

        <button 
          style={getNavBtnStyle(activeTab === 'planner')} 
          onClick={() => setActiveTab('planner')}
          onMouseOver={(e) => handleMouseOver(e, activeTab === 'planner')}
          onMouseOut={(e) => handleMouseOut(e, activeTab === 'planner')}
        >
          <span style={{ fontSize: '1.2rem' }}>🧭</span> Planner
        </button>

        <button 
          style={getNavBtnStyle(activeTab === 'journal')} 
          onClick={() => setActiveTab('journal')}
          onMouseOver={(e) => handleMouseOver(e, activeTab === 'journal')}
          onMouseOut={(e) => handleMouseOut(e, activeTab === 'journal')}
        >
          <span style={{ fontSize: '1.2rem' }}>✒️</span> Journal
        </button>

        <button 
          style={getNavBtnStyle(activeTab === 'codex')} 
          onClick={() => setActiveTab('codex')}
          onMouseOver={(e) => handleMouseOver(e, activeTab === 'codex')}
          onMouseOut={(e) => handleMouseOut(e, activeTab === 'codex')}
        >
          <span style={{ fontSize: '1.2rem' }}>🗝️</span> The Codex
        </button>

        <button 
          style={getNavBtnStyle(activeTab === 'calendar')} 
          onClick={() => setActiveTab('calendar')}
          onMouseOver={(e) => handleMouseOver(e, activeTab === 'calendar')}
          onMouseOut={(e) => handleMouseOut(e, activeTab === 'calendar')}
        >
          <span style={{ fontSize: '1.2rem' }}>📅</span> Calendar
        </button>

        <div style={{ height: '1px', backgroundColor: 'var(--muted-gold)', opacity: 0.4, margin: '15px 10px' }}></div>

        {/* Treasury Butonu - Diğerleriyle Tam Uyumlu */}
        <button 
          style={getNavBtnStyle(false)} 
          onClick={() => setShowShop(true)}
          onMouseOver={(e) => handleMouseOver(e, false)}
          onMouseOut={(e) => handleMouseOut(e, false)}
        >
          <span style={{ fontSize: '1.2rem' }}>⚜️</span> Treasury
        </button>
      </nav>

      <div className="ambience-controls" style={{ padding: '0 20px', marginTop: '40px' }}>
        <h4 style={{marginBottom: '15px', color: 'var(--muted-gold)', fontSize: '0.8rem', letterSpacing: '2px', paddingLeft: '10px', opacity: 0.8}}>AMBIENCE</h4>
        <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
          <button 
            style={getNavBtnStyle(audioState.playing && audioState.currentTrack === 'rain')} 
            onClick={() => playTrack('rain')}
            onMouseOver={(e) => handleMouseOver(e, audioState.playing && audioState.currentTrack === 'rain')}
            onMouseOut={(e) => handleMouseOut(e, audioState.playing && audioState.currentTrack === 'rain')}
          >
            <span style={{ fontSize: '1.2rem' }}>💧</span> Rain
          </button>
          <button 
            style={getNavBtnStyle(audioState.playing && audioState.currentTrack === 'fire')} 
            onClick={() => playTrack('fire')}
            onMouseOver={(e) => handleMouseOver(e, audioState.playing && audioState.currentTrack === 'fire')}
            onMouseOut={(e) => handleMouseOut(e, audioState.playing && audioState.currentTrack === 'fire')}
          >
            <span style={{ fontSize: '1.2rem' }}>🕯️</span> Fire
          </button>
          <button 
            style={getNavBtnStyle(audioState.playing && audioState.currentTrack === 'cafe')} 
            onClick={() => playTrack('cafe')}
            onMouseOver={(e) => handleMouseOver(e, audioState.playing && audioState.currentTrack === 'cafe')}
            onMouseOut={(e) => handleMouseOut(e, audioState.playing && audioState.currentTrack === 'cafe')}
          >
            <span style={{ fontSize: '1.2rem' }}>🌌</span> Mind
          </button>
        </div>
      </div>

      <div style={{ marginTop: 'auto', width: '100%', padding: '0 20px' }}>
        <div style={{ height: '1px', backgroundColor: 'var(--accent-red)', opacity: 0.4, margin: '15px 0' }}></div>
        <button 
          onClick={signOut} 
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
            width: '100%', padding: '12px', background: 'transparent', border: '1px solid rgba(122, 19, 24, 0.4)',
            color: 'var(--accent-red)', fontFamily: 'Cinzel, serif', fontSize: '1.05rem', letterSpacing: '1px',
            cursor: 'pointer', borderRadius: '6px', transition: 'all 0.2s', fontWeight: 'bold'
          }}
          onMouseOver={(e) => { 
            e.currentTarget.style.backgroundColor = 'rgba(122, 19, 24, 0.1)'; 
            e.currentTarget.style.color = '#ffffff';
          }}
          onMouseOut={(e) => { 
            e.currentTarget.style.backgroundColor = 'transparent'; 
            e.currentTarget.style.color = 'var(--accent-red)';
          }}
        >
          <span style={{ fontSize: '1.2rem' }}>🚪</span> Escape Realm
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;